var Utility = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods and Variables
     * ========================================================================
    */

    return {
        /**
         * Displays an info toast with the message "This functionality is coming soon :)"
         */
        comingSoon: function () {
            const message = "This functionality is coming soon :)";
            FD.notify.info(message, null, null, { dismissAllNotifications: true });
        },

        /**
         * Create a Ladda button.
         * @param {JQLite} $button
         */
        createLadda: function ($button) {
            if (!$button.hasClass("ladda-button")) {
                $button.addClass('ladda-button').attr('data-style', 'expand-right').append('<span class="ladda-spinner"></span>');
            }

            // start Ladda and save to data
            return Ladda.create($button[0]);
        },

        /**
         * Starts a Ladda button (this function will create it if it isn't already a Ladda button).
         * "this" should be a control_form, a button, or an anchor
         */
        startLadda: function () {
            let $laddaButton = $();

            if ($(this).is("[data-fd-control=form]")) {
                $laddaButton = $(this).control_form("popTriggerElement"); // if we are using an FD form control, the trigger element is what we want
            } else if (this.element && this.element.is("[data-fd-control=form]")) {
                if (this.element.control_form("valid")) {
                    $laddaButton = this.element.control_form("popTriggerElement"); // if we are using an FD form control, the trigger element is what we want
                }
            } else {
                $laddaButton = $("[type=submit]:visible,button:not([type]):visible", this) // find any submit buttons with the "this" as the parent context
                    .add($(this).filter("a,button")); // add this if it is an anchor or a button
            }

            if (!$laddaButton.length) {
                return null; // invalid "this"
            }

            // create and start Ladda
            const ladda = Utility.createLadda($laddaButton).start();
            $laddaButton.data("fd-ladda", ladda);
            return ladda;
        },


        /**
         * Stops a Ladda button
         * "this" should be a or a parent of a Ladda button
         */
        stopLadda: function () {
            const $laddaButton = $(".ladda-button", this) // find all Laddas from the context of "this"
                .add($(this).filter(".ladda-button")); // include this in case it is an anchor or button 

            $laddaButton.each(function () {
                const ladda = $(this).data("fd-ladda");
                if (ladda) {
                    $(this).prop("disabled", false);
                    ladda.stop();
                }
            });
        },

        /**
         * Toggles d-none on all siblings of "this"
         */
        toggleSiblingsDisplay: function () {
            $(this).siblings().add(this).toggleClass("d-none");
        },

        /**
         * Toggles d-none on all children of "this"
         */
        toggleChildrenDisplay: function () {
            $(this).children().toggleClass("d-none");
        },

        /**
         * TODO: not implemented (missing js library possibly...)
         */
        blockUI: function (elem) {
            if (elem) {
                $(elem).block({
                    message: '<i class="fa fa-fw fa-spinner fa-spin"></i>',
                    overlayCSS: {
                        backgroundColor: '#fff',
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                });
            } else {
                $.blockUI({
                    message: '<i class="fa fa-fw fa-spinner fa-spin"></i>',
                    overlayCSS: {
                        backgroundColor: '#fff',
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                });
            }
        },

        /**
         * TODO: not implemented (missing js library possibly...)
         */
        unblockUI: function (elem) {
            if (elem) {
                $(elem).unblock();
            } else {
                $.unblockUI();
            }
        },

        /**
         * Uses the selector ':input,[data-name]' to collect all values into an object where the names of the elements are properties.
         * All property names are parsed so that if a "." exists, the property name will only be everything up after that point.
         * fd-control types that are supported are: select, number, checkbox, toggle, and datepicker.
         * Other elements that are supported are: toggle buttons, non-inputs (the .text() will be the value), inputs with data-value, and inputs
         * @param {string|JQLite} container An optional parameter that should be a selector or a jQuery object
         */
        getControlValuesByContainer: function (container) {
            const fldList = container ? $(container).find(':input,[data-name]') : $(':input,[data-name]');
            var ctrlAR = {};

            fldList.each(function () {
                var elem = $(this);
                var fldName = (elem.data('name') ? elem.data('name') : this.name).split('.').pop();
                var controlType = elem.data('fd-control');
                var val;

                if (controlType === 'select') {
                    val = elem.val();
                } else if (controlType === 'number') {
                    val = elem.val();
                } else if (controlType === 'checkbox' || controlType === 'toggle') {
                    val = elem.is(':checked');
                } else if (controlType === 'datepicker') {
                    if (elem.data("type") === 'range') {
                        val = elem.val().split('-');
                        if (val.length > 0) {
                            ctrlAR[fldName + "Start"] = val[0].trim();
                            ctrlAR[fldName + "End"] = val[1].trim();
                            return;
                        }
                    }
                    val = elem.val();
                } else if (elem.hasClass("btn-group") && elem.data("toggle") === "buttons") {
                    val = $("label.btn-primary.active", elem).children()[0].id;
                } else if (controlType === 'button') {
                    return;
                } else if (elem.is(':not(:input)')) {
                    val = elem.text().trim();
                } else {
                    if (elem.data('value')) {
                        val = elem.data('value');
                    } else {
                        val = elem.val();
                    }
                }

                ctrlAR[fldName] = val;
            });

            return ctrlAR;
        },

        /**
         * The common function executed when an ajax-unobtrusive fails
         * @param {{status: number, getResponseHeader: function(string): string }} jqXhR
         */
        onFailure: function (jqXhR) {
            Utility.stopLadda.call(this); // in case ladda is running, we will want the user to be able to resubmit

            switch (jqXhR.status) {
                case 400:
                    FD.notify.alert(jqXhR.getResponseHeader('error-message'));
                    break;
                case 401:
                    FD.notify.alert("Unauthorized. Please refresh this page.");
                    break;
                default:
                    FD.notify.alert("An error has occurred. Please try to hard refresh your page.");
                    break;
            }
        },

        /**
         * "this" should have a data-ajaxUpdate attribute that is set to a selector.
         * That selector will have it's jQuery object's FD controls enabled.
         */
        enableControls: function () {
            var self = $($(this).data("ajaxUpdate"));
            self.enableControls();
        },

        /**
         * "this" should be a control_form. It will be reset.
         */
        resetForm: function () {
            $(this).control_form('reset');
        },

        /**
        * A RegExp variant for string.indexOf(). 
        * @param {string} str Your string
        * @param {RegExp|string} pattern A pattern to search for. If using a string, str.indexOf(pattern, start) will be used.
        * @param {number} start An index position to start searching at. Defaults to 0.
        */
        regexIndexOf: function (str, pattern, start = 0) {
            if (start < 0) {
                return -1;
            }

            if (typeof pattern === "string") {
                // pattern is a simple string, we can use the built-in string.indexOf function instead
                return str.indexOf(pattern, start);
            }

            const indexOf = str.substring(start).search(pattern);

            if (indexOf === -1) {
                return indexOf;
            }

            return indexOf + start;
        },

        /**
         * Find the nth index of a pattern in a string.
         * @param {string} str Your string
         * @param {RegExp|string} pattern A pattern to search for.
         * @param {number} n The number of patterns to search for from the start of str.
         */
        indexOfNthOccurrence: function (str, pattern, n) {
            let nthIndex = -1;

            for (let i = 0; i < n; i++) {
                nthIndex = FD.Utility.regexIndexOf(str, pattern, nthIndex + 1);

                if (nthIndex === -1) {
                    break;
                }
            }

            return nthIndex;
        },

        /**
         * Replaces the nth occurrence of a pattern in a string with a new value.
         * @param {string} str Your string
         * @param {RegExp|string} pattern A pattern to search for.
         * @param {number} n The number of patterns to search for from the start of str.
         * @param {string} replace The string to replace pattern with.
         */
        replaceAtNthOccurrence: function (str, pattern, n, replace) {
            if (n === 1) {
                // since n is 1, we can simply do a replace
                return str.replace(pattern, replace); 
            }

            const nthIndex = FD.Utility.indexOfNthOccurrence(str, pattern, n);

            if (nthIndex === -1) {
                return str; // there wasn't an nth occurrence of pattern
            }

            return str.substring(0, nthIndex) + str.substring(nthIndex).replace(pattern, replace);
        },

        /**
         * Resets a list typically used for posting back to the server.
         * It sequentially updates all indexes.
         * @param {string|JQLite} itemSelector A JQuery selector 
         * @param {number} listDepth How many "lists" deep is this sequence? Ex. Model.Parents[0].Children[0] - Children is at listDepth = 2
         */
        resetSequence: function (itemSelector, listDepth = 1) {
            // iterate over all items in sequence
            $(this).find(itemSelector).each((index, item) => ['name', 'data-valmsg-for'] // add more attributes to update here as we need them.
                // iterate over all attributes we want to update
                .forEach((attribute) => $(`[${attribute}]`, item)
                    // iteratate over all elements with the attribute
                    .each((_, element) => updateSequence($(element), attribute, index)))
            );

            /**
             * @param {JQLite} $this
             * @param {string} name
             */
            function updateSequence($this, name, index) {
                const pattern = /\[\d*\]/;
                const replace = `[${index}]`;
                const newName = FD.Utility.replaceAtNthOccurrence($this.attr(name), pattern, listDepth, replace);

                $this.attr(name, newName);
            }
        },

        /**
         * Removes an item of a sequence and gracefully handles resetting the sequence.
         * The sequence is a list used typically for posting back to the server.
         * The sequence item removed is returned.
         * @param {string|JQLite} itemSelector
         * @returns {JQLite}
         */
        removeSequenceItem: function (itemSelector) {
            let parent = $(this).closest(itemSelector).parent();
            $(this).popover('dispose');
            $(this).closest("form").addClass("dirty");
            const $itemRemoved = $(this).closest(itemSelector).remove();

            Utility.resetSequence.call(parent, itemSelector);

            return $itemRemoved;
        },

        /**
         * Adds an item of a sequence and gracefully handles resetting the sequence.
         * The sequence is a list used typically for posting back to the server.
         * The sequence item added is returned.
         * @param {string|JQLite} templateSelector
         * @param {string|JQLite} insertBeforeSelector
         * @param {string|JQLite} sequenceItemSelector
         * @param {any} dataFdValue the value to set onto inputDataFdValueSelector
         * @param {string|JQLite} inputDataFdValueSelector
         * @returns {JQLite}
         */
        addSequenceItem: function (templateSelector, insertBeforeSelector, sequenceItemSelector, dataFdValue, inputDataFdValueSelector) {
            const item = $(templateSelector)
                .clone()
                .attr('data-fd-value', dataFdValue)
                .removeAttr('id')
                .insertBefore(insertBeforeSelector)
                .removeClass('d-none')
                .enableControls();
            item.find(inputDataFdValueSelector).prop("disabled", false).val(dataFdValue); // if this is a sequence item, there should be a hidden input for form to post the sequence
            item.closest("form").addClass("dirty"); // the form should be marked as dirty
            Utility.resetSequence.call(item.parent(), sequenceItemSelector);
            return item; // return the item for any other page specific updates
        },

        /**
         * JS redirect that also gracefully handles dirty forms.
         * @param {string} url
         */
        redirect: function (url) {
            // persist state and clean dirty form
            $(".d-clean-none:visible").removeClass("d-clean-none");
            $(".d-dirty-none:not(:visible)").addClass("d-none");
            $("form").dirtyForms("setClean").removeClass('force-dirty');

            window.location = url;
        }
    };
}();